import SectionHeading from "../ui/SectionHeading";

type Experience = {
  name: string;
  role: string;
  date: string;
};

const ExperienceSection = ({ experiences }: { experiences: Experience[] }) => (
  <section className="experience-section section-shell" id="experience">
    <SectionHeading
      index="02"
      label="Experience / timeline"
      title="Seven years across product teams, platforms, and partnerships."
      align="right"
    />

    <div className="experience-layout">
      <div className="experience-layout__aside" data-reveal>
        <p>
          A career shaped by long-term product work, focused contracts, and
          hands-on development across web, mobile, database, and backend
          systems.
        </p>
        <span>2019—Present</span>
      </div>

      <ol className="experience-timeline">
        <span className="experience-timeline__track" aria-hidden="true" />
        <span className="experience-timeline__progress" aria-hidden="true" />
        {experiences.map((experience, index) => (
          <li key={`${experience.name}-${experience.role}`} data-reveal>
            <span className="experience-timeline__dot" aria-hidden="true" />
            <span className="experience-timeline__index">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div>
              <p>{experience.date}</p>
              <h3>{experience.name}</h3>
              <h4>{experience.role}</h4>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ExperienceSection;
